import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { RouterModule } from '@angular/router';
import {ComponentsModule} from '../components/components.module';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TabsModule} from 'ngx-bootstrap/tabs';

import { TableModule } from 'primeng/table';
import { LocationCollectionsViewComponent } from './list/list.component';
import { LocationCollectionsService } from './location-collections.service';
import { LocationCollectionResolver } from './list/list.resolver';
import { NewLocationCollectionComponent } from './new/new.component';
import { EditLocationCollectionComponent } from './edit/edit.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        RouterModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TableModule
    ],
    declarations: [
        LocationCollectionsViewComponent,
        NewLocationCollectionComponent,
        EditLocationCollectionComponent
    ],
    exports: [
        LocationCollectionsViewComponent
    ],
    providers: [
        LocationCollectionsService,
        { provide: 'LocationCollectionResolver', useValue: LocationCollectionResolver }
    ]
})
export class LocationCollectionsModule { }
